import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import * as _ from 'underscore';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { WorkflowDataService } from '../../../services/workflow/workflow-data.service';
import { GaEventService } from '../../../services/ga-event.service';
import { FormattingService } from '../../../services/formatting.service';

const AGREEMENT_NEEDED: string[] = [
  'PLACED',
  'VALIDATED'
];

@Component({
  selector: 'add-status-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class AddStatusActionComponent extends BaseReportActionsDialog implements OnInit {
  private typeField:IExtraFieldConfigurationObject;
  private statusField:IExtraFieldConfigurationObject;
  private agreementField:IExtraFieldConfigurationObject;

  constructor(
    private formlyService: GaFormlyService,
    private workflowDataService: WorkflowDataService,
    private formattingService:FormattingService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.model = {
      sendMail: true,
      stepDate: new Date()
    };
    this.fields = this.createFields();
    this.fillFields();
  }

  private onTypeFieldChange = (selectedStatusId: string): void => {
    if (selectedStatusId) {
      if (_.contains(AGREEMENT_NEEDED, selectedStatusId)) {
        this.agreementField.templateOptions.label = this.agreementLabel(selectedStatusId);
        this.agreementField.hide = false;
      } else {
        this.agreementField.hide = true;
      }

      const workflowType: string = this.workflowDataService.getWorkflowType(this.rowSelection, this.action);
      this.formlyService.fillField(this.statusField, this.workflowDataService.loadWorkflowStepDefinitions(workflowType, selectedStatusId));
    }
  };

  private createFields(): IExtraFieldConfigurationObject[] {
    this.typeField = this.formlyService.aSelect('statusTypeId', 'Type')
      .isRequired()
      .onChange(this.onTypeFieldChange)
      .build();

    this.agreementField = this.formlyService.aCheckbox('agreement', 'Agreement')
      .isRequired()
      .withHideExpression(() => !_.contains(AGREEMENT_NEEDED, this.model.statusTypeId))
      .withoutWrapper()
      .withWrapperClass('row group')
      .withValueClass('col-sm-push-3 col-sm-9')
      .withValidationMessage('required', 'Agreement is required')
      .build();

    this.statusField = this.formlyService.aSelect('stepDefId', 'Status')
      .isRequired()
      .isDisabled()
      .withHideExpression(() => !this.model.statusTypeId)
      .withValueProp('id')
      .withLabelProp('value')
      .build();

    return [
      this.typeField,
      this.agreementField,
      this.statusField,
      this.formlyService.aDateInput('stepDate', 'Status date')
        .isRequired()
        .withHideExpression(() => !this.model.statusTypeId)
        .withFormat(this.formattingService.formatDate)
        .build(),
      this.formlyService.aTextarea('comments', 'Comments').build(),
      this.formlyService.aCheckbox('sendMail', 'Send mail for this update')
        .withoutWrapper()
        .build()
    ];
  }

  private fillFields(): void {
    const workflowType: string = this.workflowDataService.getWorkflowType(this.rowSelection, this.action);
    this.formlyService.fillField(this.typeField, this.workflowDataService.loadWorkflowStatuses(workflowType));
  }

  private agreementLabel(status: string): string {
    return `By putting the order on ${status} you agree to pay the order fees and you confirm the default SLA/VAT/TAX/shipping charges are correct. 
          You can still edit the order after you have put it on ${status} but you need to make the changes on GA. 
          Your invoice must be 100% compliant to the GA PO.`;
  }
}